<template>
  <div style="display: flex; align-items: center; justify-content: end;">
    <span style="width: 70px;">
      <RenderMoneyColumnValue :value="invoiceValue" />
    </span>
    <span style="padding: 0 5px;">|</span>
    <span style="width: 20px;">
      <RenderPanoramaInvoiceStatus
        :panorama-invoice-status="panoramaInvoiceStatus"
      />
    </span>
  </div>
</template>

<script>
import { RenderMoneyColumnValue } from '../../../ui/render';
import RenderPanoramaInvoiceStatus from './render-panorama-invoice-status-value.vue';

export default {
  components: { RenderMoneyColumnValue, RenderPanoramaInvoiceStatus },
  props: {
    invoiceValue: {
      type: Number,
      default: 0,
    },
    panoramaInvoiceStatus: {
      type: String,
      default: '',
    },
  },
};
</script>
